import { useQuery } from '@apollo/client';
import loadable from '@loadable/component';
import Loader from 'Components/Forms/Loader';
import ErrorState from 'Components/ErrorState';
import { GET_PRODUCT } from 'graphql/secure/queries';
import { useLogEventOnMount } from 'hooks/useLogEvent';
import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TRouteParamsWithId } from 'types/router.types';

const LoadableAnalytics = loadable(
  () => import('FeatureModules/ProductPage/Components/MainAnalytics'),
  {
    fallback: <Loader />,
  }
);

const ProductMainAnalytics: FC = () => {
  const { id } = useParams<TRouteParamsWithId>();
  useLogEventOnMount('VIEW_PRODUCT_ANALYTICS', { productId: id });
  const { error, loading, data } = useQuery(GET_PRODUCT, {
    variables: { id },
  });

  useEffect(() => {
    LoadableAnalytics.preload();
  }, []);

  if (error) return <ErrorState error={error} />;
  if (!data && loading) return <Loader />;

  return <LoadableAnalytics />;
};

export default ProductMainAnalytics;
